export default __webpack_public_path__ + "static/media/corporate_admin_members.abec1e39.svg";